import { render, staticRenderFns } from "./GoodDetail.vue?vue&type=template&id=1233f338&scoped=true&"
import script from "./GoodDetail.vue?vue&type=script&lang=js&"
export * from "./GoodDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodDetail.vue?vue&type=style&index=0&id=1233f338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1233f338",
  null
  
)

export default component.exports